import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  solid,
  regular,
  brands,
} from "@fortawesome/fontawesome-svg-core/import.macro";
function HeaderMenu(props) {
  return (
    <div className="flex gap-1">
      <div>
        <h1 className="font-semibold flex justify-center items-center gap-1">
          {props.title}
        </h1>
      </div>
      <div className="mt-0.5">
        <FontAwesomeIcon icon={solid("caret-down")} size="xs" />
      </div>
    </div>
  );
}

export default HeaderMenu;
